module.exports = __webpack_public_path__ + "images/home_160.jpg";